import { useCallback } from 'react';
import { Box } from '@chakra-ui/react';
import { Button } from '@mercator-gcp/grout';
import { Spinner } from 'components/elements/Spinner';
import { FlexRow } from 'components/layout/FlexRow';
import { List } from 'components/layout/List';
import ProjectCard from 'components/widgets/ProjectCard';
import StreetViewMap from 'components/widgets/StreetViewMap';
import { useProjectsOnAPin } from 'hooks/projectMap/useProjectsOnAPin';
import { ViewProjectDetailsClickLocations } from 'utils/analytics/constants';

const containerStyle = {
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
};

const loaderStyle = {
  ...containerStyle,
  padding: 'padding_16',
};

const loadMoreWrapperStyle = {
  justifyContent: 'center',
};

const cardOverrideStyle = {
  borderRadius: 'none',
};

type Props = {
  lat: number;
  lng: number;
};

const SelectedProjectList = ({ lat, lng }: Props) => {
  const { projectsList, setPage } = useProjectsOnAPin();

  const handleLoadMoreClick = useCallback(() => {
    if (projectsList?.data?.nextPage) {
      setPage((p: any) => p + 1);
    }
  }, [projectsList?.data?.nextPage, setPage]);

  if (projectsList.isLoading || projectsList.isFetching) {
    return (
      <Box sx={loaderStyle}>
        <Spinner size="lg" />
      </Box>
    );
  }

  if (!projectsList?.data?.count) {
    return null;
  }

  return (
    <Box sx={containerStyle}>
      {lat && lng && <StreetViewMap lat={lat} lng={lng} />}
      <List>
        <List.Body>
          {projectsList?.data?.projects?.map((project) => (
            <ProjectCard
              key={project.slug}
              project={project}
              clickLocation={ViewProjectDetailsClickLocations.MAP}
              sx={cardOverrideStyle}
            />
          ))}
          {projectsList?.data?.nextPage && (
            <FlexRow sx={loadMoreWrapperStyle}>
              <Button onClick={handleLoadMoreClick}>Load More</Button>
            </FlexRow>
          )}
        </List.Body>
      </List>
    </Box>
  );
};

export default SelectedProjectList;
